import { useState, useEffect, useRef } from 'react';

const stats = [
  { label: 'En Çok İncelenen', value: 'Lazer Epilasyon', sub: '342 görüntülenme', icon: 'ri-fire-line', color: '#d4af37' },
  { label: 'Ortalama Süre', value: '4:32', sub: 'dakika / ziyaret', icon: 'ri-time-line', color: '#00d9ff' },
  { label: 'WhatsApp Tıklaması', value: '128', sub: 'bu hafta', icon: 'ri-whatsapp-line', color: '#25d366' },
  { label: 'Form Bırakanlar', value: '67', sub: 'potansiyel müşteri', icon: 'ri-user-add-line', color: '#d4af37' },
];

const funnelSteps = [
  { label: 'Giriş', value: 100, color: '#d4af37' },
  { label: 'Kampanya İnceleme', value: 78, color: '#f4d03f' },
  { label: 'Detay Sayfası', value: 54, color: '#00d9ff' },
  { label: 'Teklif Görüntüleme', value: 38, color: '#00b8d9' },
  { label: 'İletişim', value: 22, color: '#25d366' },
];

const exitPoints = [
  { label: 'Ana Sayfa', pct: 12 },
  { label: 'Kampanya Listesi', pct: 24 },
  { label: 'Detay Sayfası', pct: 31 },
  { label: 'Teklif Adımı', pct: 18 },
  { label: 'İletişim Formu', pct: 15 },
];

function AnimatedBar({ value, color, delay }: { value: number; color: string; delay: number }) {
  const [width, setWidth] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setWidth(value), delay);
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [value, delay]);

  return (
    <div ref={ref} className="h-2 bg-white/5 rounded-full overflow-hidden">
      <div
        className="h-full rounded-full transition-all duration-1000 ease-out"
        style={{ width: `${width}%`, backgroundColor: color }}
      />
    </div>
  );
}

export default function DashboardSection() {
  return (
    <section id="yonetim-paneli" className="relative py-20 md:py-28 bg-[#0a0a0f] overflow-hidden">
      {/* BG glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-[#d4af37]/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#d4af37]/30 bg-[#d4af37]/5 text-[#d4af37] text-xs font-semibold uppercase tracking-widest mb-5">
            <i className="ri-bar-chart-2-line"></i>
            Yönetim Paneli
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4 leading-tight">
            Yönetim Panelinden{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#f4d03f]">
              Her Şeyi Görün
            </span>
          </h2>
          <p className="text-white/50 text-base md:text-lg max-w-2xl mx-auto">
            Ziyaretçilerinizin her adımı kayıt altında. Hangi kampanyayı inceledi, nerede durdu, ne zaman yazdı — hepsi panelde.
          </p>
        </div>

        {/* Dashboard Mock UI */}
        <div className="relative rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-sm overflow-hidden">
          {/* Top bar */}
          <div className="flex items-center justify-between px-5 py-3 border-b border-white/10 bg-white/[0.02]">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-red-500/70" />
              <div className="w-3 h-3 rounded-full bg-yellow-500/70" />
              <div className="w-3 h-3 rounded-full bg-green-500/70" />
            </div>
            <span className="text-white/30 text-xs font-mono">nova-guzellik.smartpro.panel</span>
            <div className="flex items-center gap-1.5 text-[#25d366] text-xs font-semibold">
              <span className="w-1.5 h-1.5 rounded-full bg-[#25d366] animate-pulse inline-block" />
              Canlı
            </div>
          </div>

          <div className="p-5 md:p-8">
            {/* KPI Cards */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
              {stats.map((s, i) => (
                <div
                  key={i}
                  className="rounded-xl border border-white/10 bg-white/[0.04] p-4 hover:border-white/20 transition-all duration-300 group"
                >
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-white/40 text-xs">{s.label}</span>
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg" style={{ backgroundColor: `${s.color}15` }}>
                      <i className={`${s.icon} text-sm`} style={{ color: s.color }}></i>
                    </div>
                  </div>
                  <div className="text-xl md:text-2xl font-black text-white mb-1">{s.value}</div>
                  <div className="text-white/30 text-xs">{s.sub}</div>
                </div>
              ))}
            </div>

            {/* Two columns */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Funnel */}
              <div className="rounded-xl border border-white/10 bg-white/[0.03] p-5">
                <div className="flex items-center justify-between mb-5">
                  <h4 className="text-white font-bold text-sm">Ziyaretçi Hunisi</h4>
                  <span className="text-white/30 text-xs">Bu Hafta</span>
                </div>
                <div className="flex flex-col gap-4">
                  {funnelSteps.map((step, i) => (
                    <div key={i}>
                      <div className="flex items-center justify-between mb-1.5">
                        <span className="text-white/60 text-xs">{step.label}</span>
                        <span className="text-white font-bold text-xs">{step.value}%</span>
                      </div>
                      <AnimatedBar value={step.value} color={step.color} delay={i * 150} />
                    </div>
                  ))}
                </div>
              </div>

              {/* Exit Points */}
              <div className="rounded-xl border border-white/10 bg-white/[0.03] p-5">
                <div className="flex items-center justify-between mb-5">
                  <h4 className="text-white font-bold text-sm">Çıkış Noktaları</h4>
                  <span className="text-[#d4af37] text-xs font-semibold">Analiz</span>
                </div>
                <div className="flex flex-col gap-3">
                  {exitPoints.map((ep, i) => (
                    <div key={i} className="flex items-center gap-3">
                      <div className="w-6 h-6 flex items-center justify-center rounded-md bg-white/5 text-white/40 text-xs font-bold flex-shrink-0">
                        {i + 1}
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center justify-between mb-1">
                          <span className="text-white/60 text-xs">{ep.label}</span>
                          <span className="text-white/40 text-xs">%{ep.pct}</span>
                        </div>
                        <div className="h-1.5 bg-white/5 rounded-full overflow-hidden">
                          <div
                            className="h-full rounded-full bg-gradient-to-r from-red-500/60 to-red-400/40"
                            style={{ width: `${ep.pct * 3}%` }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Recent activity */}
                <div className="mt-5 pt-4 border-t border-white/5">
                  <div className="text-white/30 text-xs mb-3">Son Aktiviteler</div>
                  <div className="flex flex-col gap-2">
                    {[
                      { text: 'Lazer Epilasyon detayı incelendi', time: '2 dk önce', dot: '#d4af37' },
                      { text: 'WhatsApp butonuna tıklandı', time: '5 dk önce', dot: '#25d366' },
                      { text: 'Fırsat listesine kayıt', time: '11 dk önce', dot: '#00d9ff' },
                    ].map((a, i) => (
                      <div key={i} className="flex items-center gap-2">
                        <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ backgroundColor: a.dot }} />
                        <span className="text-white/50 text-xs flex-1">{a.text}</span>
                        <span className="text-white/20 text-xs whitespace-nowrap">{a.time}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Strong message */}
        <div className="mt-10 text-center">
          <div className="inline-flex items-center gap-3 px-8 py-4 rounded-2xl border border-[#d4af37]/30 bg-[#d4af37]/5">
            <i className="ri-eye-line text-[#d4af37] text-xl"></i>
            <span className="text-white font-bold text-lg md:text-xl">
              Tahmin etmezsiniz,{' '}
              <span className="text-[#d4af37]">görürsünüz.</span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
